import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import { ValidationSPA } from "./validation_Component"; // validationSPAコンポーネントをインポート
// 【マウント処理】validationSPAコンポーネントをHTMLの特定の要素にマウントする処理
// コンポーネントはエクスポートして、マウント処理は分けることが一般的。分けることでコンポーネントの再利用性が高まり、テストもしやすくなる。
// ファイル先頭でrootを1回だけ作成（複数回呼び出すとエラーになるため）
const rootElement = document.getElementById("root");
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(_jsx(ValidationSPA, {}));
}
